/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class ChannelsService {
  constructor(private httpClient: HttpClient) {}

  getChannelById(channelId: number) {
    return this.httpClient.get(`${environment.apiHostname}/v1/channels/${channelId}`).pipe(
      map((subscription: any) => subscription.data),
      catchError((error: any) => error)
    );
  }
}
